import { FC } from 'react';
import { ShopperMesh } from '../../../../../types';
import './ShopperOrderNumber.less';

interface ShopperOrderNumberProps {
  shopperMesh: ShopperMesh;
  selectedQueueLineColor: string;
  isSelectedShopper: boolean;
  isOverlapping: boolean;
  isFirstInLine: boolean;
  isMiddleInLine: boolean;
  isLastInLine: boolean;
}

const ShopperOrderNumber: FC<ShopperOrderNumberProps> = ({
  shopperMesh,
  selectedQueueLineColor: _selectedQueueLineColor,
  isSelectedShopper,
  isOverlapping,
  isFirstInLine,
  isMiddleInLine,
  isLastInLine,
}) => {
  return (
    <div className="shopper-order-number-wrapper">
      {(isFirstInLine || isMiddleInLine) && (
        <div
          style={{
            height: '15px',
            width: '3px',
            background: '#003D4C',
            position: 'absolute',
            top: '40px',
          }}
        />
      )}

      <div
        className="shopper-order-number"
        style={{
          borderColor: '#003D4C',
          color: isSelectedShopper ? '#ffffff' : '#003D4C',
          background: isSelectedShopper ? '#003D4C' : '#ffffff',
        }}
      >
        {shopperMesh.userData.orderInLine}
      </div>

      {isOverlapping && (
        <div
          className="alert-overlapping-shopper"
          title="Shoppers are overlapping and need to be moved."
        >
          !
        </div>
      )}

      {(isLastInLine || isMiddleInLine) && (
        <div
          style={{
            height: '15px',
            width: '3px',
            background: '#003D4C',
            position: 'absolute',
            bottom: '40px',
          }}
        />
      )}
    </div>
  );
};

export default ShopperOrderNumber;
